import type { Theme } from 'baseui';
import { Z_INDEX_LAYERS } from '../../../../constants';
export const FRAME_WIDTH = 20;
export const FRAME_HEIGHT = 24;
export const getColumnHeaderLabelHeight = ($theme: Theme) => $theme.typography.LabelXSmall.lineHeight;
export const getColumnHeaderBreakpointPointerHeight = ($theme: Theme) => $theme.sizing.scale300;
export const getColumnHeaderBreakpointPointerMarginTop = ($theme: Theme) => $theme.sizing.scale100;
export const getColumnHeaderPaddingVertical = ($theme: Theme) => $theme.sizing.scale300;
export const getColumnHeaderHeight = ($theme: Theme) => {
  const paddingVertical = getColumnHeaderPaddingVertical($theme);
  const labelHeight = getColumnHeaderLabelHeight($theme);
  const breakpointPointerHeight = getColumnHeaderBreakpointPointerHeight($theme);
  const breakpointPointerMarginTop = getColumnHeaderBreakpointPointerMarginTop($theme);
  return `calc(${paddingVertical} + ${labelHeight} + ${breakpointPointerHeight} + ${breakpointPointerMarginTop} + ${paddingVertical})`;
};
export const ROW_HEADER_WIDTH = 120;
export const KEYFRAME_WIDTH = 16;
export const ANNOTATION_BODY_CONTRACTED_MAX_FRAMES = 4;
export const ANNOTATION_BODY_EXPANDED_MAX_FRAMES = 10;
export const DRAG_HANDLE_SIZE = 24;
export const MARKER_LINE_SIZE = 2;
export const AUTOSCROLL_THRESHOLD_WIDTH = FRAME_WIDTH * 4;
export const HOVERED_COLUMN_Z_INDEX = Z_INDEX_LAYERS.TWO;
export const CURRENT_FRAME_MARKER_Z_INDEX = Z_INDEX_LAYERS.THREE;
export const ROW_HEADER_Z_INDEX = Z_INDEX_LAYERS.FOUR;
export const EDIT_ANNOTATION_CELL_Z_INDEX = Z_INDEX_LAYERS.FIVE;
export const EDIT_ANNOTATION_POPOVER_Z_INDEX = Z_INDEX_LAYERS.FIVE;